import { classNames } from '@/utils/style/classNames';

export type ProductCatalogView = 'classic' | 'faceted';

interface ProductCatalogViewToggleProps {
  value: ProductCatalogView;
  onChange: (view: ProductCatalogView) => void;
}

const ProductCatalogViewToggle = ({ value, onChange }: ProductCatalogViewToggleProps) => {
  const options: { value: ProductCatalogView; label: string }[] = [
    { value: 'classic', label: 'Classic' },
    { value: 'faceted', label: 'Filters' },
  ];

  return (
    <div
      className="inline-flex rounded-md border border-gray-300 bg-white p-1"
      data-testid="product-catalog-view-toggle"
    >
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={classNames(
            'px-3 py-1.5 text-sm font-medium rounded',
            value === option.value ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-100',
          )}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default ProductCatalogViewToggle;
